import { render } from "./WeChat.vue?vue&type=template&id=45cdc2e4&ts=true"
import script from "./WeChat.vue?vue&type=script&lang=ts"
export * from "./WeChat.vue?vue&type=script&lang=ts"

import "./WeChat.vue?vue&type=style&index=0&id=45cdc2e4&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__